import classNames from 'classnames'
import * as flags from 'images/flags'
import * as icons from 'images/icons'
import React, { memo } from 'react'

import { makeStyles } from '@mui/styles'

interface Props {
  className?: string
  name?: string
}

const useStyles = makeStyles({
  root: {
    color: 'initial',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    height: '1.2rem',
    marginRight: '0.2rem',
    width: '1.2rem',
  },
})

function CommonIcon({ className, name = '' }: Props) {
  const simpleName = name.replaceAll('-', '').replaceAll(' ', '')
  const classes = useStyles()
  // TODO: Find better typing
  const Icon = icons[simpleName as 'lastYear'] || flags[simpleName as 'apparel']

  if (!Icon) {
    return null
  }

  return <Icon className={classNames(classes.root, className)} />
}

export default memo<Props>(CommonIcon)
